import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Fade, Spinner } from 'reactstrap';
import { Subscribe } from 'unstated';
import PageLoaderService, { pageLoader } from '../../../services/PageLoader';
import './styles.scss';
import { breadcrumbs } from '../../../filters';

export default withRouter(class Breadcrumbs extends Component {
    render() {
      const { pathname } = this.props.location;

      return (
        <Subscribe to={[PageLoaderService]}>
          {() => (
            <>
              <Breadcrumb className="float-left">
                <BreadcrumbItem><Link className="text-secondary" to="/">Главная</Link></BreadcrumbItem>
                {breadcrumbs(pathname).map(({ title, link, isActive, key }) => {
                  if (isActive) {
                    return <BreadcrumbItem key={key} active={true}><span className="text-secondary">{title}</span></BreadcrumbItem>;
                  }

                  return <BreadcrumbItem key={key}><Link className="text-secondary" to={link}>{title}</Link></BreadcrumbItem>;
                })}
              </Breadcrumb>

              <Fade className="float-left" in={pageLoader.state.isLoading} timeout={0}>
                <Spinner className="breadcrumb_spinner" size="sm" color="primary"/>
              </Fade>
            </>
          )}
        </Subscribe>
      );
    }
  }
);
